import { createAction } from 'redux-actions';

export const getPendingWithdrawalRequest = createAction('GET_PENDING_WITHDRAWAL_REQUEST');
export const getPendingWithdrawalSuccess = createAction('GET_PENDING_WITHDRAWAL_SUCCESS');
export const getPendingWithdrawalFail = createAction('GET_PENDING_WITHDRAWAL_FAIL');

export const generatePendingWithdrawalRequest = createAction('GENERATE_PENDING_WITHDRAWAL_REQUEST');
export const generatePendingWithdrawalSuccess = createAction('GENERATE_PENDING_WITHDRAWAL_SUCCESS');
export const generatePendingWithdrawalFail = createAction('GENERATE_PENDING_WITHDRAWAL_FAIL');
